
const initialState = {
  data: null,
  loading: true,
  error: null,
};

export const urlConfig = (state = initialState, action) => {
  switch (action.type) {
    case 'CONFIG_LOAD_START':
      return { ...state, loading: true, error: null };
    case 'CONFIG_LOAD_SUCCESS':
      return { ...state, data: action.payload, loading: false };
    case 'CONFIG_LOAD_ERROR':
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
